module.exports = __webpack_public_path__ + "img/41.c78fa76b.jpg";